import { Card } from "@mui/material";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";

const DateCard: React.FC<{ children: string }> = ({ children }) => (
  <Card>
    <MDBox p={1} sx={(theme) => ({ background: theme.palette.grey[100] })}>
      <MDTypography variant="button">{children}</MDTypography>
    </MDBox>
  </Card>
);

export default DateCard;
